<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-lavuro">
            <span class="pull-left">
              <h4 class="card-title ">Suscripciones</h4>
              <p class="card-category">Des / Habilitar Features por Empresa</p>
            </span>
            <span class="pull-right">
              <button mat-raised-button type="button" class="btn btn-lavuro p-2" (click)="openNewSubscriptionModal()"> 
                <i class="material-icons">add</i> Nuevo
              </button>
            </span>
          </div>
          <div class="card-body">
            <div class="table-striped">
              <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortSubscriptions($event)" stickyHeader
                stickyFooter>

                <thead class="text-lavuro">
                  <tr>

                    <!-- All -->
                    <th class="p-0 pl-2">
                      <div class="form-check m-0 mx-2">
                        <label class="form-check-label">
                          <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                            [checked]="selection.all">
                          <span class="form-check-sign">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                    </th>

                    <!-- PC -->
                    <th class="d-none d-md-table-cell">
                      Empresa
                    </th>
                    <th class="d-none d-md-table-cell">
                      Features
                    </th>

                    <!-- Mobile -->
                    <th class="d-table-cell d-md-none">
                      Orden por: <span class="ml-2">{{sortOptions[filter.sort || ''] || 'ninguno'}}</span>
                      <span class="text-lavuro pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
                    </th>

                    <!-- All -->
                    <th class="td-actions text-right p-0">
                      <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                        [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                        <i class="material-icons">more_vert</i>
                      </button>
                      <mat-menu #menu="matMenu">

                        <!-- sort order -->
                        <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                          <span>Orden</span>
                        </button>

                        <!-- filters -->
                        <button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button>
                      </mat-menu>

                      <mat-menu #order="matMenu">
                        <ng-container *ngFor="let key of sortOptionsKeys">
                          <button mat-menu-item (click)="sortSubscriptions(key)">
                            <span>{{sortOptions[key]}}</span>
                          </button>
                        </ng-container>
                        <button mat-menu-item (click)="sortSubscriptions('')">
                          <span>Sin Ordenar</span>
                        </button>
                      </mat-menu>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let subscription of subscriptions" [class.text-danger]="subscription.isDeleted" class='cursor-pointer'
                    (click)="openSubscriptionModal(subscription, true)">

                    <!-- All -->
                    <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                      <div class="form-check m-0 mx-2">
                        <label class="form-check-label">
                          <input class="form-check-input input-sm" type="checkbox"
                            (click)="toggleSelection(subscription._id)" [checked]="selection.all || selection[subscription._id || '']">
                          <span class="form-check-sign">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                    </td>

                    <!-- PC -->
                    <td class="d-none d-md-table-cell">{{subscription.company?.name}}</td>
                    <td class="d-none d-md-table-cell">
                      <span *ngFor="let feature of subscription.features">{{feature.name}}.&nbsp;&nbsp;</span>
                    </td>

                    <!-- Mobile -->
                    <td class="d-table-cell d-md-none" style="line-height: 14px;">
                      <b>{{subscription.company?.name}}</b><br>
                      <span *ngFor="let feature of subscription.features">{{feature.name}}<br></span>
                      <span style="line-height: 15px;" class="small">
                        <span class="pull-right" *ngIf="subscription.isDeleted">borrada</span>
                      </span>
                    </td>

                    <!-- All -->
                    <td class="td-actions text-right p-0">
                      <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                        [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                        <i class="material-icons">more_vert</i>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="openSubscriptionModal(subscription, true)">
                          <span>Abrir</span>
                        </button>
                        <button mat-menu-item (click)="openSubscriptionModal(subscription)">
                          <span>Modificar</span>
                        </button>
                        <button mat-menu-item (click)="openDeleteSubscriptionConfirm(subscription, true)" *ngIf="isDev">
                          <span>Hard Delete</span>
                        </button>
                        <button mat-menu-item (click)="openDeleteSubscriptionConfirm(subscription)" *ngIf="!subscription.isDeleted">
                          <span>Eliminar</span>
                        </button>
                        <button mat-menu-item (click)="openRestoreSubscriptionConfirm(subscription)" *ngIf="subscription.isDeleted">
                          <span>Restaurar</span>
                        </button>
                      </mat-menu>
                    </td>
                  </tr>

                  <!-- All -->
                  <tr *ngIf="thereAreMore && !loading">
                    <td colspan="10">
                      <button class="btn btn-link text-lavuro text-capitalize p-0" (click)='loadMore()'>+ cargar
                        mas</button>
                    </td>
                  </tr>
                  <tr *ngIf="loading">
                    <td colspan="10">Cargando...</td>
                  </tr>
                </tbody>
                <tfoot class="text-lavuro">
                  <tr>
                    <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ subscriptions.length }} suscripciones</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>